import { FileDownload } from "@mui/icons-material";
import "./Download.css";

const Download = () => {
  return (
    <button
      className="download-button"
      onClick={() => {
        window.canvasEngine.FeatureRenderer.handleDownloadJSON();
      }}
    >
      <FileDownload className="download-icon" />
    </button>
  );
};

export default Download;
